const STORE_KEY = 'hd-chat-log';
const SEEN_KEY = 'hd-chat-opened';
const HINT_KEY = 'hd-chat-hinted';
const HEALTH_KEY = 'hd-chat-ok';
const MAX_TURNS = 20;
const MAX_CHARS = 800;
// Oct 16: the panel no longer opens by itself (Clarity showed most visitors closing it). The first page of a
// visit shows a speech bubble next to the launcher for this long instead.
const HINT_MS = 6000;

const root = document.querySelector('[data-hd-chat]');

function readStore(key, fallback) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}

function writeStore(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {

  }
}

async function isUsable(endpoint) {
  if (readStore(HEALTH_KEY, false) === true) return true;
  try {
    const res = await fetch(endpoint.replace(/\/+$/, '') + '/health', { method: 'GET' });
    if (!res.ok) return false;
    const data = await res.json();
    if (data && data.ok === true) {
      writeStore(HEALTH_KEY, true);
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

function init(el) {
  const endpoint = el.dataset.endpoint;
  const greeting = el.dataset.greeting || 'How can I help?';
  const isProduct = el.dataset.template === 'product';

  const panel = el.querySelector('[data-hd-chat-panel]');
  const launcher = el.querySelector('[data-hd-chat-launcher]');
  const closeBtn = el.querySelector('[data-hd-chat-close]');
  const hint = el.querySelector('[data-hd-chat-hint]');
  const log = el.querySelector('[data-hd-chat-log]');
  const form = el.querySelector('[data-hd-chat-form]');
  const input = el.querySelector('[data-hd-chat-input]');
  const send = el.querySelector('[data-hd-chat-send]');

  let history = readStore(STORE_KEY, []);
  let busy = false;
  let hintTimer = null;

  if (isProduct) {
    const gallery = document.querySelector('.hd-pdp__gallery');
    if (gallery) {
      gallery.appendChild(el);
      el.classList.add('hd-chat--docked');
    } else {

      el.classList.remove('hd-chat--docked');
    }
  }

  const docked = el.classList.contains('hd-chat--docked');

  function appendText(node, text) {
    const pattern = /(https?:\/\/[^\s<>"')]+|\/(?:products|collections|pages)\/[^\s<>"')]+)/g;
    let last = 0;
    let m;
    while ((m = pattern.exec(text)) !== null) {
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      const raw = m[0].replace(/[.,;:)]+$/, '');
      let internal = raw.startsWith('/');
      if (!internal) {
        try {
          internal = new URL(raw).host === window.location.host;
        } catch (e) {
          internal = false;
        }
      }
      if (internal) {
        const a = document.createElement('a');
        a.href = raw;
        a.textContent = raw;
        node.appendChild(a);
      } else {
        node.appendChild(document.createTextNode(raw));
      }
      last = m.index + raw.length;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }

  function bubble(role, text) {
    const div = document.createElement('div');
    div.className = 'hd-chat__msg hd-chat__msg--' + role;
    if (role === 'user') div.textContent = text;
    else appendText(div, text);
    log.appendChild(div);
    log.scrollTop = log.scrollHeight;
    return div;
  }

  function typing(on) {
    const existing = log.querySelector('[data-hd-chat-typing]');
    if (!on) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    const d = document.createElement('div');
    d.className = 'hd-chat__typing';
    d.setAttribute('data-hd-chat-typing', '');
    d.setAttribute('aria-label', 'Assistant is typing');
    d.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(d);
    log.scrollTop = log.scrollHeight;
  }

  function paint() {
    log.textContent = '';
    if (!history.length) bubble('bot', greeting);
    else history.forEach((m) => bubble(m.role === 'user' ? 'user' : 'bot', m.content));
  }

  function hideHint() {
    if (hintTimer) clearTimeout(hintTimer);
    hintTimer = null;
    if (!hint || hint.hidden) return;
    hint.classList.remove('is-visible');
    // let the fade finish before taking it out of the tab order
    setTimeout(() => {
      hint.hidden = true;
    }, 250);
  }

  function showHint() {
    if (!hint) return;
    writeStore(HINT_KEY, true);
    hint.hidden = false;
    requestAnimationFrame(() => hint.classList.add('is-visible'));
    hintTimer = setTimeout(hideHint, HINT_MS);
  }

  function open(focus) {
    hideHint();
    el.classList.add('is-open');
    panel.hidden = false;
    writeStore(SEEN_KEY, true);
    if (focus) input.focus();
    log.scrollTop = log.scrollHeight;
  }

  function close() {
    el.classList.remove('is-open');
    panel.hidden = true;
    launcher.focus();
  }

  if (launcher) launcher.addEventListener('click', () => open(true));
  if (hint) hint.addEventListener('click', () => open(true));
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && el.classList.contains('is-open') && !docked) close();
  });

  async function ask() {
    busy = true;
    send.disabled = true;
    typing(true);

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: history.slice(-MAX_TURNS),
          context: {
            template: el.dataset.template || '',
            handle: el.dataset.handle || '',
            title: document.title
          }
        })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();

      if (data && data.disabled) {
        try {
          sessionStorage.removeItem(HEALTH_KEY);
        } catch (err) {

        }
        el.remove();
        return;
      }

      const reply = (data && data.reply ? String(data.reply) : '').trim();
      typing(false);
      if (!reply) throw new Error('empty reply');
      history.push({ role: 'assistant', content: reply });
      writeStore(STORE_KEY, history);
      bubble('bot', reply);
    } catch (err) {
      typing(false);
      const d = document.createElement('div');
      d.className = 'hd-chat__msg hd-chat__msg--error';
      d.textContent =
        "Sorry, I could not reach the assistant just then. You can try again, or call the shop on 1-800-542-3278 and someone will help.";
      log.appendChild(d);
      log.scrollTop = log.scrollHeight;
    } finally {
      busy = false;
      send.disabled = false;
    }
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (busy) return;
    const text = input.value.trim().slice(0, MAX_CHARS);
    if (!text) return;
    input.value = '';
    input.style.height = 'auto';
    history.push({ role: 'user', content: text });
    writeStore(STORE_KEY, history);
    bubble('user', text);
    ask();
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit();
    }
  });

  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 96) + 'px';
  });

  paint();

  if (docked) {
    panel.hidden = false;
    el.classList.add('is-open');
  } else {
    // starts minimized as its launcher; once per visit, a short "AI Shopping Assistant" bubble beside it
    panel.hidden = true;
    if (!readStore(HINT_KEY, false) && !readStore(SEEN_KEY, false)) showHint();
  }
}

async function boot() {
  if (!root || !root.dataset.endpoint) return;

  if (!(await isUsable(root.dataset.endpoint))) {
    root.remove();
    return;
  }

  root.style.display = '';
  init(root);
}

boot();
